// extracted by mini-css-extract-plugin
export default {"clubInfo":"SimpleClub_clubInfo__IJZzT","clubLogo":"SimpleClub_clubLogo__q4cSd","clubName":"SimpleClub_clubName__BYwUI"};